import utilsService from '@/app/helpers/utilsService';
import fetchWrapper from '../fetchWrapper';

const BASE_URL = process.env.BASE_URL;

interface GetPostParams {
    cursor?: string | null;
    perPage?: number;
    signal?: AbortSignal;
    condition?: string | null;
    type?: string | null;
    is_show_home?: number;
    show_at_top?: number;
    category_id?: number | null;
    ownerId?: string | number;
}

interface GetPostDetailParams {
    postId: string | number;
    signal?: AbortSignal;
}

async function getPostsDetails({ postId, signal }: GetPostDetailParams): Promise<any> {
    try {
        const response = await fetchWrapper.get(`${BASE_URL}/posts/${postId}`, { signal });
        return response;
    } catch (error) {
        throw error;
    }
}
async function getPostLists({ cursor = null, condition = '', perPage = 10, type = null, is_show_home, show_at_top, category_id, signal, ownerId }: GetPostParams): Promise<any> {
    try {
        const basePath = 'posts';
        const params = {
            cursor: cursor,
            per_page: perPage,
            group: condition !== 'common' ? condition : undefined,
            post_type: type || undefined,
            ...(is_show_home !== undefined && { is_show_home }),
            ...(show_at_top !== undefined && { show_at_top }),
            ...(category_id !== undefined && category_id !== null && { category_id }),
            ...(ownerId !== undefined && { owner_id: ownerId }),
        };

        const url = utilsService.constructUrlWithParams(basePath, params);

        const response = await fetchWrapper.get(url, { signal });
        return response;
    } catch (error) {
        throw error;
    }
}

export const postsService = {
    getPostsDetails,
    getPostLists,
};
